import React from 'react';
import TopBar from '../components/TopBar';
import PowerBIEmbed from '../components/PowerBIEmbed';

const CarbonFootprint = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="carbon-footprint" userClaims={userClaims} />
      
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-4">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Carbon Footprint Dashboard</h2>
          <PowerBIEmbed reportId="e3c338fa-b4d6-4889-a570-3d92f3563531" workspaceId="7d441575-4aa9-4260-99dd-543f002c0340" height={800} />
        </div>
      </div>
    </div>
  );
};

export default CarbonFootprint; 